// Loader.js
import React from 'react';
import './loader.css'; // Importez le fichier CSS pour le style du loader

const Loader = () => (
    <div className="loader-container">
        <div className="loader"></div>
        <p>Chargement...</p>
    </div>
);

export default Loader;
